import { Button, Space, } from "antd"
import { EventService } from "../../Services/EventService"
import ColorPicker from "../Color/ColorPicker"
import { TextService } from "../../Services/TextService"

// Matches what the event page shows when no colors are saved: dark title, #234e70 button with white text.
export const DefaultBannerImageColorCode = "#000000";
export const DefaultPrimaryColorCode = "#234e70";
export const DefaultSecondaryColorCode = "#ffffff";

export interface EventColors {
    bannerImageColorCode: string;
    primaryColorCode: string;
    secondaryColorCode: string;
}

export const DefaultEventColors: EventColors = {
    bannerImageColorCode: DefaultBannerImageColorCode,
    primaryColorCode: DefaultPrimaryColorCode,
    secondaryColorCode: DefaultSecondaryColorCode,
};

export const isSameColors = (a: EventColors, b: EventColors) =>
    a.bannerImageColorCode.toLowerCase() === b.bannerImageColorCode.toLowerCase()
    && a.primaryColorCode.toLowerCase() === b.primaryColorCode.toLowerCase()
    && a.secondaryColorCode.toLowerCase() === b.secondaryColorCode.toLowerCase();

// The colors saved on the event, or the defaults when none are saved.
export const getSavedEventColors = (event: any): EventColors => event?.primaryColorCode != null ? {
    bannerImageColorCode: event.bannerImageColorCode ?? DefaultBannerImageColorCode,
    primaryColorCode: event.primaryColorCode,
    secondaryColorCode: event.secondaryColorCode ?? DefaultSecondaryColorCode,
} : DefaultEventColors;

export const saveEventColors = async (eventId: number, colors: EventColors) => {
    await EventService.UpdateBranding({
        webApiServicesDataTransferObjectsUserServiceUpdateBrandingDto: {
            id: eventId,
            primaryColorCode: colors.primaryColorCode,
            secondaryColorCode: colors.secondaryColorCode,
            bannerImageColorCode: colors.bannerImageColorCode
        }
    });
}

// The color pickers. The page owns the colors and saves them with its own "Spara".
export const EventBranding = (props: { colors: EventColors, onChange: (colors: EventColors) => void }) => {
    const GetText = TextService.GetText;
    const colors = props.colors;

    const colorField = (label: string, value: string, key: keyof EventColors) => (
        <div style={{ minWidth: "160px" }}>
            <div style={{ marginBottom: "6px" }}>{label}</div>
            <ColorPicker color={value} onChangeComplete={(hex: string) => props.onChange({ ...colors, [key]: hex })} />
        </div>
    );

    return <>
        <Space size="large" wrap align="start" style={{ display: "flex", marginBottom: "16px" }}>
            {colorField(GetText("EventBranding_ChangeColorEventName"), colors.bannerImageColorCode, "bannerImageColorCode")}
            {colorField(GetText("EventBranding_ChangeColorEventPrimaryColor"), colors.primaryColorCode, "primaryColorCode")}
            {colorField(GetText("EventBranding_ChangeColorEventSecondaryColor"), colors.secondaryColorCode, "secondaryColorCode")}
        </Space>

        {/* Always shown so it is easy to find; greyed out when the colors already are the defaults. */}
        <div style={{ marginBottom: "16px" }}>
            <Button disabled={isSameColors(colors, DefaultEventColors)} onClick={() => props.onChange(DefaultEventColors)}>{GetText("EventBranding_ResetColors")}</Button>
        </div>
    </>
}
